import React, { useState, useEffect, useCallback } from "react";
import {
  ToggleButton,
  ToggleButtonGroup,
  Grid,
  Paper,
  Button,
  Stack,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
  Card,
  CardContent
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import Select from "react-select";
import moment from "moment";
import Axios from "axios";
import PdfReportArrear from "./PdfReportArrear";
import Sidebar from "../../sidebar/sidebar";
import { BaseUrl } from "../../../Environment";
import { companylogo } from "../../../assets/images";
import { getSecureItem } from "../../../utilsFunctions";
import { withNamespaces } from "react-i18next";
import { getCompanyProfile } from "../../../api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import excel from '../../../assets/images/excel.svg';
import pdf from '../../../assets/images/pdf.svg';
import { Workbook } from "react-excel-workbook";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const SequenceFilter = [
  { value: "onetime", label: "Onetime" },
  { value: "daily", label: "Daily" },
  ...(getSecureItem("loggedinUserCompany") == 2891 ? [{label: 'Ten_Daily', value: 'ten_daily'}] : []),
  { value: "weekly", label: "Weekly" },
  { value: "biweekly", label: "Bi-Weekly" },
  { value: "monthly", label: "Monthly" },
  { value: null, label: "All" },
];

const loanTableHeader = {
  srNo: "Sr No",
  loanId: "Loan Id",
  customerName: "Name",
  areaLine: "Area/Line",
  mobileNumber: "Phone",
  collectionAgent: "Collection Agent",
  ...(getSecureItem("loggedinUserCompany") === "3310"
    ? { nextDueDate: "Due Date" }
    : { loanAmount: "Repayable Amount" }),
  currentInstallmentDue: "Current Installment Due",
  amountCollectedTillDate: "Amount Collected(Till Date)",
  duration: "Duration",
  paidTillDate: "Paid(Till Date) ",
  notPaidTillDate: "NotPaid(Till Date)",
  unmarkedTillDate: "Unmarked(Till Date)",
  pendingDuesTillDate: "Pending Dues(Till Date)",
  lastPaymentDate: "Last Payment Date",
  outstandingBalance :"Outstanding Balance",
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#e1f0fa",
    color: theme.palette.common.black,
    fontWeight: "bold",
    textAlign: "center",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    cursor: "pointer",
    textAlign: "center",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export function getDaysWeeksMonths(tenure, tenureType) {
  switch (tenureType) {
    case "onetime":
      return "One-Time";
    case "daily":
      return `${tenure} days`;
    case "weekly":
      return `${tenure} weeks`;
    case "biweekly":
      return `${tenure * 2} weeks`;
    case "monthly":
      return `${tenure} months`;
    case "ten_daily":
      return `${tenure * 10} days`;
    default:
      return "";
  }
}

const ArrearReport = () => {
  const history = useHistory();
  toast.configure({});

  const columnWidths = [
    { wch: 200 },
    { wch: 200 },
    { wch: 250 }
  ]
  const loggedinUser = getSecureItem("loggedinUser");
  const companyId = getSecureItem("loggedinUserCompany");
  const token = getSecureItem("token");
  const headers = { Authorization: `Bearer ${token}` };

  // const [modalExtraColumn, setModalExtraColumn] = useState(false);
  // const [extraColumns, setExtraColumns] = useState({
  //   column1: "",
  //   column2: "",
  //   column3: "",
  //   column4: "",
  // });
  const [branchData, setBranchData] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [companyData, setCompanyData] = useState({});
  const [reportTableData, setReportTableData] = useState([]);
  const [loanType, setLoanType] = useState(null);
  const [loanTypeData, setLoanTypeData] = useState([]);
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [loanTenure, setLoanTenure] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userType] = useState(loggedinUser?.userType);
  const [cAgentId, setCAgentId] = useState(null);
  const [cAgentData, setCAgentData] = useState([]);
  const [checked, setChecked] = useState(false);
  const [boxData, setBoxData] = useState([]);

  const handleChangeSequence = (_, val) =>
    setLoanTenure(val === "All" ? null : val);

  const getLoanTypes = async () => {
    try {
      const res = await Axios.get(
        `${BaseUrl}/loanType/getAllLoanTypes?loanType=&companyId=${companyId}`,
        { headers }
      );
      const loanTypes = res.data?.map((data) => ({
        value: data?.loanTypeId,
        label: data?.loanType,
      }));
      setLoanTypeData(loanTypes);
    } catch (err) {
      console.error("Loan type error:", err);
    }
  };

  const getAllUsers = async () => {
    try {
      const branchId = loggedinUser?.userType == "superAdmin" ?selectedBranch?.value||"":selectedBranch?.value || loggedinUser?.branchId || ""
      const res = await Axios.get(
        `${BaseUrl}/user/getAllUsers?userName=&companyId=${companyId}&branchId=${branchId}`,
        { headers }
      );
      const users = res.data?.result || [];
      const filtered = userType === "Collection Agent" ? users.filter((u) => u.userId === loggedinUser?.userId) : users;
      setCAgentData(
        filtered.map((u) => ({
          label: `${u.firstName} ${u.lastName}`,
          value: u.userId,
        }))
      );
    } catch (err) {
      console.error("Users fetch error:", err);
    }
  };

  const getCompany = async () => {
    try {
      const compData = await getCompanyProfile();
      const {
        profilePic,
        companyName,
        GstIn,
        companyWebsite,
        phone,
        companyMail,
        AddressStreet,
        AddressLandmark,
        AddressCity,
        AddressState,
        AddressPincode,
      } = compData;
      setCompanyData({
        profilePic,
        companyName,
        GstIn,
        companyWebsite,
        phone,
        companyMail,
        address: {
          AddressStreet,
          AddressLandmark,
          AddressCity,
          AddressState,
          AddressPincode,
        },
      });
    } catch (error) {
      console.log({ error });
    }
  };


  const fetchBranches = async () => {
    try {
      const token = getSecureItem("token");
      const headers = {
        Authorization: "Bearer " + token,
      };

      const { data } = await Axios.get(`${BaseUrl}/branch/getAllBranches`, {
        params: { companyId: loggedinUser.companyId },
        headers,
      });

      const branchData = loggedinUser?.userType == "superAdmin" ? data?.data : data?.data?.filter((item) => item?.branchId == loggedinUser?.branchId);

      setBranchData(branchData?.map(item => ({
        label: item.branchName,
        value: item.branchId
      })) || []);
    } catch (err) {
      console.error("Fetch Branches Error:", err);
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  const getArrearReport = useCallback(async () => {
    setLoading(true);
    try {
      const dateMoment = moment(date);
      const isToday = moment().isSame(dateMoment, "day");

      const payload = {
        fromDate: isToday
          ? dateMoment.startOf("day").format("YYYY-MM-DD")
          : dateMoment.format("YYYY-MM-DD"),
        toDate: isToday
          ? dateMoment.endOf("day").format("YYYY-MM-DD")
          : dateMoment.format("YYYY-MM-DD"),
        companyId,
        loanTypeId: loanType?.value || null,
        loanTenureType: loanTenure || null,
        collectorId: cAgentId?.value || null,
        checked: checked,
        branchId: loggedinUser?.userType == "superAdmin" ?selectedBranch?.value || null:selectedBranch?.value || loggedinUser?.branchId || null,
      };

      const res = await Axios.post(
        `${BaseUrl}/loanCollection/getdueloanReport`,
        payload,
        { headers }
      );
      setReportTableData(res.data);
    } catch (error) {
      console.error("Arrear report error:", error);
    } finally {
      setLoading(false);
    }
  }, [checked, selectedBranch, date, companyId, loanType, loanTenure, cAgentId, loggedinUser?.userId]);

  useEffect(() => {
    getLoanTypes();
    getAllUsers();
    getCompany();
  }, []);

  useEffect(() => {
    getArrearReport();
  }, [getArrearReport]);

  useEffect(() => {
  if (!reportTableData || reportTableData.length === 0) {
    setBoxData([
    { label: "Total Repayable Amount",  value: 0  },
    { label: "Total Current Dues", value: 0 },
    { label: "Total Pending Dues", value: 0 },
    { label: "Total Outstanding Balance", value: 0 },
  ]);
    return;
  }

  const totalRepayableAmount = reportTableData.reduce(
    (sum, data) => sum + (Number(data?.totalAmountToCollect) || 0), 0
  );
  const totalCurrentDues = reportTableData.reduce(
    (sum, data) => sum + (Number(data?.installment) || 0), 0
  );
    const totalOutStanding = reportTableData.reduce(
    (sum, data) => sum + (Number(data?.outStanding) || 0), 0
  );
  const totalPendingDues = reportTableData.reduce(
    (sum, data) => sum + (Number(data?.pendingDuesTD) || 0), 0
  );

  setBoxData([
    // { label: "Total Count", value: reportTableData?.length || 0 },
    { label: "Total Repayable Amount",  value: totalRepayableAmount  },
    { label: "Total Current Dues", value: totalCurrentDues },
    { label: "Total Pending Dues", value: totalPendingDues },
    { label: "Total Outstanding Balance", value: totalOutStanding },
  ]);
}, [reportTableData]);

  const resetData = () => {
    setCAgentId(null);
    setLoanType(null);
    setDate(moment().format("YYYY-MM-DD"));
    setLoanTenure(null);
    setSelectedBranch(null);
  };

  const getLabelByValue = (value) =>
    cAgentData?.find((item) => item.value === value)?.label || null;

  // const handleChange = (key, value) => {
  //   setExtraColumns((prev) => ({ ...prev, [key]: value }));
  // };

  const navigateToLoanDetails = (loanId) => {
    history.push({
      pathname: '/customers/customerinfo',
      state: { loanID: loanId }
    })
  }

  return (
    <>
      <Sidebar />
      <div style={{ marginLeft: 73, height: "100vh" }}>
        {loading ? (
          <Grid container justifyContent="center" mt={2}>
            <CircularProgress />
          </Grid>
        ) : (
          <Grid container direction="column">
            <Grid item sx={{ backgroundColor: "#fff" }}>
              <div style={{ margin: 5 }}>
                <img src={companylogo} width={200} height={40} alt="logo" />
              </div>
            </Grid>
            <strong
              style={{ textAlign: "center", marginTop: 10, fontSize: 18 }}
              className="Fonts"
            >
              Day - Wise Demand/Arrear Report
            </strong>
            <Grid container spacing={2} paddingX={4} paddingY={2}>
              <Grid item xs={12} sm={6} md={4}>
                <Select
                  options={cAgentData}
                  value={cAgentId}
                  onChange={setCAgentId}
                  placeholder="Select Collection-Agent"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Select
                  options={loanTypeData}
                  value={loanType}
                  onChange={setLoanType}
                  placeholder="Select Loan Type"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <input
                  type="date"
                  style={{
                    borderWidth: "1px",
                    borderColor: "lightgray",
                    borderRadius: "4px",
                    width: "95%",
                    padding: "10px",
                  }}
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <ToggleButtonGroup
                  color="primary"
                  value={loanTenure}
                  exclusive
                  onChange={handleChangeSequence}
                  size="small"
                >
                  {SequenceFilter.map((filter) => (
                    <ToggleButton key={filter.value} value={filter.value}>
                      {filter.label}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Button
                  variant="outlined"
                  onClick={resetData}
                  style={{ width: 300 }}
                >
                  Reset
                </Button>
              </Grid>
               <Grid item xs={12} sm={6} md={4}>
                  <Select
                    options={branchData}
                    isDisabled={(loggedinUser?.company?.planId == 3) ? false : true}
                    value={selectedBranch}
                    onChange={(val) => setSelectedBranch(val)}
                    placeholder="Select Branch"
                  />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Stack direction={"row"} alignItems="center" gap={2}>
                  <p className="Fonts">Download Reports: </p>
                  <img src={pdf} alt="pdf" className="pdficon" onClick={() => PdfReportArrear({
                    sortedData: reportTableData,
                    selectedCA: cAgentId?.value,
                    cAgentData,
                    date,
                    loanType: loanType?.value,
                    loanTypeData,
                    loanTenure,
                    companyData,
                    addEC: false,
                    // extraColumns,
                    boxData: boxData
                  })} style={{cursor: "pointer"}} />
                  <Workbook filename="arrear_report.xlsx" element={<img src={excel} alt="excel" className="excelicon" style={{cursor: "pointer"}} />}>
                    <Workbook.Sheet
                      data={reportTableData?.map((data, index) => {
                        const borrowerName = `${data?.customer?.firstName || ""} ${data?.customer?.lastName || ""}`.trim();
                        const custId = data?.customer?.cust_id ? `(${data.customer.cust_id})` : "";
                        
                        return {
                          srNo: index + 1,
                          loanId: data.loanId,
                          customerName: `${borrowerName} ${custId}`.trim(),
                          areaLine: data?.customer?.areaLine,
                          mobileNumber: data?.customer?.phone || "-",
                          collectionAgent: getLabelByValue(data?.collectorId),
                          ...(getSecureItem("loggedinUserCompany") === "3310"
                            ? { nextDueDate: moment(data?.nextDueDate).format("LL") }
                            : { loanAmount: data?.totalAmountToCollect }),
                          currentInstallmentDue: data?.installment,
                          amountCollectedTillDate: data?.collectedAmount,
                          duration: getDaysWeeksMonths(data?.loanTenure, data?.loanTenureType),
                          paidTillDate: data?.paidCln,
                          notPaidTillDate: data?.notPaidCln,
                          unmarkedTillDate: data?.unmarkedCln,
                          pendingDuesTillDate: data?.pendingDuesTD,
                          lastPaymentDate: data?.lastCollectedDate ? moment(data?.lastCollectedDate).format("LL") : "",
                          outstandingBalance: data?.outStanding,
                        };
                      })}
                      columsWidths={columnWidths}
                      name="Arrear Report"
                    >
                      <Workbook.Column label="Sr No" value="srNo" />
                      <Workbook.Column label="Loan Id" value="loanId" />
                      <Workbook.Column label="Customer Name (Customer Id)" value="customerName" />
                      <Workbook.Column label="Area/Line" value="areaLine" />
                      <Workbook.Column label="Mobile Number" value="mobileNumber" />
                      <Workbook.Column label="Collection Agent" value="collectionAgent" />
                      {getSecureItem("loggedinUserCompany") === "3310" ? (
                        <Workbook.Column label="Due Date" value="nextDueDate" />
                      ) : (
                        <Workbook.Column label="Repayable Amount" value="loanAmount" />
                      )}
                      <Workbook.Column label="Current Installment Due" value="currentInstallmentDue" />
                      <Workbook.Column label="Amount Collected Till Date" value="amountCollectedTillDate" />
                      <Workbook.Column label="Duration" value="duration" />
                      <Workbook.Column label="Paid Till Date" value="paidTillDate" />
                      <Workbook.Column label="Not-Paid Till Date" value="notPaidTillDate" />
                      <Workbook.Column label="Unmarked Till Date" value="unmarkedTillDate" />
                      <Workbook.Column label="Pending Dues Till Date" value="pendingDuesTillDate" />
                      <Workbook.Column label="Last Payment Date" value="lastPaymentDate" />
                      <Workbook.Column label="Outstanding Balance" value="outstandingBalance" />
                    </Workbook.Sheet>
                  </Workbook>
                </Stack>
                {/* <Button
                  onClick={() => setModalExtraColumn(true)}
                  style={{
                    padding: "10px 20px",
                    backgroundColor: "#007bff",
                    color: "#fff",
                    borderRadius: 5,
                  }}
                >
                  Download PDF Report
                </Button> */}
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={() => setChecked(!checked)}
                    />
                  }
                  label="Pending dues till Date"
                />
              </Grid>
            </Grid>

            <Grid container spacing={3} paddingX={4} paddingTop={2} marginBottom={2}>
              {boxData?.map((data, i) => (<Grid key={i} item xs={12} sm={6} md={3}>
                <Card
                  elevation={1}
                  sx={{ borderRadius: 3, bgcolor: "#fff", boxShadow: "0px 3px 10px 4px rgba(36, 38, 52, 0.1)" }}
                >
                  <CardContent>
                    <div className="Fonts" style={{ fontSize: 22, fontWeight: 600 }}>
                      {data?.value} {(i == 1 || i == 2) && getSecureItem("country")?.symbol}
                    </div>
                    <div className="Fonts" style={{ fontSize: 14, color: "#666", marginTop: 4 }}>
                      {data?.label}
                    </div>
                  </CardContent>
                </Card>
              </Grid>))}
            </Grid>
            
            <Grid item container paddingX={4} paddingY={2}>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }}>
                  <TableHead>
                    <TableRow>
                      {Object.entries(loanTableHeader).map(([key, label]) => (
                        <StyledTableCell key={key}>{label}</StyledTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {reportTableData?.map((data, index) => (
                      <StyledTableRow key={data?.loanId || index}>
                        <StyledTableCell>{index + 1}</StyledTableCell>
                        <StyledTableCell>
                          <span
                            onClick={() => navigateToLoanDetails(data?.loanId)}
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                          >
                            {data?.loanId}
                          </span>
                        </StyledTableCell>
                        <StyledTableCell>
                          <div>{`${data?.customer?.firstName || ""} ${data?.customer?.lastName || ""}`}</div>
                          {data?.customer?.cust_id && (
                            <div>({data.customer.cust_id})</div>
                          )}
                        </StyledTableCell>
                        <StyledTableCell>
                          {data?.customer?.areaLine}
                        </StyledTableCell>
                        <StyledTableCell>
                          {data?.customer?.phone || "-"}
                        </StyledTableCell>
                        <StyledTableCell>
                          {getLabelByValue(data?.collectorId)}
                        </StyledTableCell>
                        {getSecureItem("loggedinUserCompany") === "3310" ? (
                          <StyledTableCell>{moment(data?.nextDueDate).format("LL")}</StyledTableCell>
                        ) : (
                          <StyledTableCell>{data?.totalAmountToCollect}</StyledTableCell>
                        )}
                        <StyledTableCell>{data?.installment}</StyledTableCell>
                        <StyledTableCell>
                          {data?.collectedAmount}
                        </StyledTableCell>
                        <StyledTableCell>
                          {getDaysWeeksMonths(data?.loanTenure, data?.loanTenureType)}
                        </StyledTableCell>
                        <StyledTableCell>{data?.paidCln}</StyledTableCell>
                        <StyledTableCell>{data?.notPaidCln}</StyledTableCell>
                        <StyledTableCell>{data?.unmarkedCln}</StyledTableCell>
                        <StyledTableCell>{data?.pendingDuesTD}</StyledTableCell>
                        <StyledTableCell>{data?.lastCollectedDate && moment(data?.lastCollectedDate).format("LL")}</StyledTableCell>
                        <StyledTableCell>{data?.outStanding}</StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        )}
      </div>

      {/* <Dialog
        fullWidth
        maxWidth="sm"
        open={modalExtraColumn}
        onClose={() => setModalExtraColumn(false)}
      >
        <DialogContent>
          <strong className="Fonts" style={{ fontSize: 18 }}>
            Would you like to add custom columns at the end of the report?
          </strong>
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              marginTop: 2,
            }}
          >
            <Paper elevation={1} sx={{ p: 2, width: "100%" }}>
              <Stack spacing={2}>
                <TextField
                  hiddenLabel
                  value={extraColumns.column1}
                  inputMode="text"
                  type="text"
                  placeholder="Column 1"
                  onChange={(e) => handleChange("column1", e.target.value)}
                  variant="outlined"
                  fullWidth
                />
                <TextField
                  hiddenLabel
                  value={extraColumns.column2}
                  inputMode="text"
                  type="text"
                  placeholder="Column 2"
                  onChange={(e) => handleChange("column2", e.target.value)}
                  variant="outlined"
                  fullWidth
                />
                <TextField
                  hiddenLabel
                  value={extraColumns.column3}
                  inputMode="text"
                  type="text"
                  placeholder="Column 3"
                  onChange={(e) => handleChange("column3", e.target.value)}
                  variant="outlined"
                  fullWidth
                />
                <TextField
                  hiddenLabel
                  value={extraColumns.column4}
                  inputMode="text"
                  type="text"
                  placeholder="Column 4"
                  onChange={(e) => handleChange("column4", e.target.value)}
                  variant="outlined"
                  fullWidth
                />
              </Stack>
            </Paper>
          </Box>
        </DialogContent>
        <DialogActions>
          <Stack direction={"row"} spacing={2}>
            <Button
              variant="outlined"
              onClick={() => {
                setModalExtraColumn(false);
                PdfReportArrear({
                  sortedData: reportTableData,
                  selectedCA: cAgentId?.value,
                  cAgentData,
                  date,
                  loanType: loanType?.value,
                  loanTypeData,
                  loanTenure,
                  companyData,
                  addEC: false,
                  extraColumns,
                  boxData: boxData
                });
              }}
            >
              Skip
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                const extraColumnValues =
                  Object.values(extraColumns).filter(
                    (val) => val?.toString().trim() !== ""
                  ) || [];
                const extraColumnCount = extraColumnValues.length;

                if (extraColumnCount > 0) {
                  setModalExtraColumn(false);
                  PdfReportArrear({
                    sortedData: reportTableData,
                    selectedCA: cAgentId?.value,
                    cAgentData,
                    date,
                    loanType: loanType?.value,
                    loanTypeData,
                    loanTenure,
                    companyData,
                    addEC: true,
                    extraColumns,
                    boxData: boxData
                  });
                  setTimeout(() => {
                    setExtraColumns({
                      column1: "",
                      column2: "",
                      column3: "",
                      column4: "",
                    });
                  }, 1000);
                } else {
                  toast.info("Please enter value for columns.", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                  });
                }
              }}
            >
              Add Columns
            </Button>
          </Stack>
        </DialogActions>
      </Dialog> */}
    </>
  );
};

export default withNamespaces()(ArrearReport);
